export * from './easy-collection';
export * from './google';
export * from './magenty';
export * from './mobile';
export * from './shopilink';
export * from './web';
